import getStaticPropsWrapper from "@/lib/utils/getStaticPropsWrapper";
import {getAboutUs} from "@/lib/api/sanity/api";
import React from "react";
import AboutUs from "@/components/pages/aboutUs/AboutUs";

export default function Page({body}) {
  return <AboutUs body={body}/>
}

export const getStaticProps = getStaticPropsWrapper(async ({wrapperProps}) => {
  const {config} = wrapperProps.props;
  const aboutUs = await getAboutUs({config});
  return {
    props: {
      body: aboutUs.body ?? []
    }
  }
})
